import { useParams, useNavigate } from 'react-router-dom';
import { useState, useEffect } from 'react';
import { Typography, Box, Divider } from '@material-ui/core';

import Page from '../components/Page';
import useVrackApi from '../hooks/useVrackApi';
import { BeautyView } from '../components/team/SnapshotSummary';

const SNAPSHOT_NOT_FOUND_SUBSTR = 'no entry found in database';
export default function SnapshotDetails() {
  const [snapshot, setSnapshot] = useState();
  const navigate = useNavigate();
  const { snapshotname } = useParams();

  const { fetchData: vrackApiSnapshotDetails } = useVrackApi(
    'get',
    `/racks/snapshot/${snapshotname}`
  );

  const getSnapshotDetails = async (snapshotname, setSnapshot) => {
    await vrackApiSnapshotDetails('get', `/racks/snapshot/${snapshotname}`)
      .then((response) => {
        console.debug('Snapshot details were successfully retrieved from the API');
        setSnapshot(response);
        return snapshot;
      })
      .catch((error) => {
        console.debug(error);
        if (snapshotExists(snapshotname, error)) {
          navigate('/404', { replace: true });
          return;
        }
        // Check if error is due to not being authorized to view the page
        if (error.response && error.response.status === 401) {
          navigate('/401', { replace: true });
        }
      });
  };

  function snapshotExists(snapshotname, error) {
    if (error.response?.data?.message?.includes(SNAPSHOT_NOT_FOUND_SUBSTR)) {
      return !!snapshotname;
    }

    return false;
  }
  useEffect(() => {
    if (snapshotname) {
      getSnapshotDetails(snapshotname, setSnapshot);
    }
    // eslint-disable-next-line
  }, [snapshotname]);

  return (
    <Page title={`${snapshotname} Details`} data-testid="snapshot-details-page">
      <Box ml={2} marginRight={3} padding={2}>
        <Typography variant="h3">Snapshot Details</Typography>
        <Divider />
        <Box sx={{ marginTop: 1 }}>
          <Typography
            variant="subtitle2"
            sx={{
              textTransform: 'uppercase',
              fontWeight: 100,
              letterSpacing: 3,
              opacity: 0.7,
              display: 'inline-block',
              marginRight: 1
            }}
          >
            {snapshotname}
          </Typography>
        </Box>
      </Box>

      <Box padding={3}>
        <BeautyView data={snapshot} />
      </Box>
    </Page>
  );
}
